export default {
  // Hero section
  'hero.title': 'पेशेवर ऑनलाइन टाइमर टूल',
  'hero.subtitle': 'अपनी आवश्यकताओं के लिए सही समय टूल चुनें',

  // Tool cards
  'timer.title': 'टाइमर',
  'timer.description': 'काम, अध्ययन और जीवन के लिए काउंटडाउन टाइमर',
  'timer.longDescription': 'उत्पादकता, खाना पकाने और समय प्रबंधन के लिए काउंटडाउन टाइमर',
  'timer.button': 'टाइमर शुरू करें',

  'stopwatch.title': 'स्टॉपवॉच',
  'stopwatch.description': 'उच्च-सटीक समय टूल',
  'stopwatch.longDescription': 'खेल, प्रशिक्षण और सटीक समय के लिए उच्च-सटीक स्टॉपवॉच',
  'stopwatch.button': 'स्टॉपवॉच शुरू करें',

  'worldclock.title': 'विश्व घड़ी',
  'worldclock.description': 'दुनिया भर के समय क्षेत्र देखें',
  'worldclock.longDescription': 'बुद्धिमान समय क्षेत्र गणना के साथ वैश्विक प्रमुख शहर के समय का वास्तविक समय प्रदर्शन',
  'worldclock.button': 'विश्व घड़ी देखें',

  // Features section
  'features.title': 'timer.today क्यों चुनें?',
  'features.reliable.title': 'विश्वसनीय और सटीक',
  'features.reliable.desc': 'ब्राउज़र-आधारित विश्वसनीयता के साथ मिलीसेकंड सटीकता समय',
  'features.crossPlatform.title': 'क्रॉस-प्लेटफ़ॉर्म',
  'features.crossPlatform.desc': 'डेस्कटॉप, टैबलेट और मोबाइल डिवाइस पर निर्बाध रूप से काम करता है',
  'features.smartNotifications.title': 'स्मार्ट सूचनाएं',
  'features.smartNotifications.desc': 'समय समाप्त होने पर ध्वनि अलर्ट और डेस्कटॉप सूचनाएं',
  'features.easyToUse.title': 'उपयोग में आसान',
  'features.easyToUse.desc': 'सभी उपयोगकर्ताओं के लिए सहज नियंत्रण के साथ साफ इंटरफ़ेस',

  // Keywords section
  'keywords.timer': 'timer countdown pomodoro focus work break',
  'keywords.chinese': '计时器 倒计时 番茄钟 专注 休息',
  'keywords.japanese': 'タイマー カウントダウン ポモドーロ 集中 休憩',
  'keywords.spanish': 'temporizador cuenta regresiva pomodoro concentración',
  'keywords.german': 'Timer Countdown Pomodoro Konzentration Pause',
  'keywords.french': 'minuteur compte à rebours pomodoro concentration',
  'keywords.russian': 'таймер обратный отсчет помодоро концентрация',
};
